import { render, staticRenderFns } from "./DumbbellIcon.vue?vue&type=template&id=16ebd417&"
import script from "./DumbbellIcon.vue?vue&type=script&lang=ts&"
export * from "./DumbbellIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports